import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePlatformMode } from '../hooks/usePlatformMode';
import { LoadingSpinner } from '../UI/ComponnentsUI/common/LoadingSpinner';

interface PlatformModeRouteProps {
  children: React.ReactNode;
  allowedModes?: ('full' | 'api_as_service')[];
  fallbackPath?: string;
}

const PlatformModeRoute: React.FC<PlatformModeRouteProps> = ({ 
  children, 
  allowedModes = ['full', 'api_as_service'],
  fallbackPath = '/home' 
}) => {
  const { mode, loading } = usePlatformMode();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!allowedModes.includes(mode)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default PlatformModeRoute;
